import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const KEY = "mercadito_cart";
const RV_KEY = "mercadito_recently_viewed";

const load = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
const itemKey = (pid, vid) => `${pid}|${vid || ""}`;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = useCallback((productId, variantId, quantity = 1) => {
    setItems((prev) => {
      const k = itemKey(productId, variantId);
      const existing = prev.find((i) => itemKey(i.product_id, i.variant_id) === k);
      if (existing) return prev.map((i) => itemKey(i.product_id, i.variant_id) === k ? { ...i, quantity: i.quantity + quantity } : i);
      return [...prev, { product_id: productId, variant_id: variantId || null, quantity }];
    });
  }, []);

  const remove = useCallback((productId, variantId) => {
    const k = itemKey(productId, variantId);
    setItems((prev) => prev.filter((i) => itemKey(i.product_id, i.variant_id) !== k));
  }, []);

  const setQty = useCallback((productId, variantId, quantity) => {
    const k = itemKey(productId, variantId);
    setItems((prev) => prev.map((i) => itemKey(i.product_id, i.variant_id) === k ? { ...i, quantity: Math.max(1, quantity) } : i));
  }, []);

  const changeVariant = useCallback((productId, oldVariantId, newVariantId) => {
    setItems((prev) => {
      const k = itemKey(productId, oldVariantId);
      const cur = prev.find((i) => itemKey(i.product_id, i.variant_id) === k);
      if (!cur) return prev;
      const rest = prev.filter((i) => itemKey(i.product_id, i.variant_id) !== k);
      const newK = itemKey(productId, newVariantId);
      const merge = rest.find((i) => itemKey(i.product_id, i.variant_id) === newK);
      if (merge) return rest.map((i) => itemKey(i.product_id, i.variant_id) === newK ? { ...i, quantity: i.quantity + cur.quantity } : i);
      return [...rest, { ...cur, variant_id: newVariantId }];
    });
  }, []);

  const clear = useCallback(() => setItems([]), []);
  const count = items.reduce((n, i) => n + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, changeVariant, clear, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const addRecentlyViewed = (id) => {
  try {
    let rv = JSON.parse(localStorage.getItem(RV_KEY)) || [];
    rv = [id, ...rv.filter((x) => x !== id)].slice(0, 12);
    localStorage.setItem(RV_KEY, JSON.stringify(rv));
  } catch {}
};
export const getRecentlyViewed = () => { try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch { return []; } };
